<p-messages [severity]="severity" [styleClass]="noMargin ? 'my-0' : 'my-4'">
  <ng-template pTemplate>
    <div class="flex align-items-center">
      <i class="mi-round mi-error mr-2"></i>
      <p class="my-0 p4 font-semibold message-text">
        <ng-content></ng-content>
      </p>
    </div>
  </ng-template>
</p-messages>
